import React from 'react';
import Button, {ButtonProps, ButtonSize, ButtonType} from "../../../gd-components/buttons/gd-button/gd-button-ui5-new";
import FormManager from "../form-manager";
import FormModel from "../form-model-manager";

type Props = ButtonProps & {
    className?      : string

    label?          : string
    size?           : ButtonSize | '30'|'36'

    icon?           : string,
    iconPosition?   : 'left'|'right'
    type?           : string // eto button type i.e. busy no po mnoemu eto bred - eto z submit ...

    form?           : FormModel | FormManager

    hideIfDisabled? : boolean,

    onClick?        : callback,    // if passed redefine defrault form submit action
}

export default class ButtonSubmit extends React.Component<Props> {

    public form? : FormManager | FormModel

    static defaultProps = {
        iconPosition    : 'left',
        size            : ButtonSize.STANDARD,
        label           : "Submit"
    };

    constructor(props: Props) {
        super(props);

        this.form = this.props.form;
    }

    componentDidMount() {
        if (this.form) this.form.registerSubmitButton(this);
    }

    setForm = (form : FormManager | FormModel) => {
        if (!this.form) {
            this.form = form;
            this.form.registerSubmitButton(this);
            this.forceUpdate();
        } else console.warn("ButtonSubmitNew setForm error: form already set");
    };

    onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation();

        if (this.props.type === 'busy') {
            e.preventDefault();
        } else {
            if(this.props.onClick) this.props.onClick()
            else if (this.form) this.form.onSubmitClick.call(this.form)
        }
    };

    render() {
        let type = 'primary';

        // const size:string = _.get(this.props, 'size', '36')
        // const iconPosition:string = _.get(this.props, 'iconPosition', 'left')

        if (this.form) {
            if (this.form.isSubmitting) {
                type = ButtonType.BUSY
            } else if (this.form.isFormValid && this.form.isFormChanged) {
                type = ButtonType.PRIMARY
            }
        }

        if (this.props.hideIfDisabled && type !== ButtonType.PRIMARY && type !== ButtonType.BUSY) {
            return null
        }

        return (
            <Button className       = {Classes('btn-submit', this.props.className)}
                    size            = {this.props.size}
                    type            = {type}
                    label           = {_.get(this.props,'label','Submit')}
                    icon            = {this.props.icon}
                    iconPosition    = {this.props.iconPosition}
                    disabled        = {this.props.disabled}
                    onClick         = {this.onClick}/>
        );
    }
}
